export const ACCEPTABLE_ORGS = [
    { id: 7104883, name: 'J&H Lanmark' },
    { id: 7104884, name: 'Mast General Stores' },
    { id: 7104885, name: 'Acadia Shops' },
    { id: 7104886, name: 'Maine Sport Outfitters' },
];
